/* eslint-disable func-names */
/* eslint-disable no-use-before-define */
import _ from 'lodash';

Mobi2Go._class = Mobi2Go._class || {};

let cid = 0;
const { mixinEvents } = Mobi2Go.app;

function ModifierGroup(modifier_group, parent_product) {
    if (!(this instanceof ModifierGroup)) {
        return new ModifierGroup(modifier_group, parent_product);
    }

    this.init(modifier_group, parent_product);
}

Mobi2Go._class.OrderProductModifierGroup = ModifierGroup;

_.extend(ModifierGroup.prototype, {
    init(modifier_group, parent_product) {
        if (
            !(modifier_group instanceof Mobi2Go._class.MenuItem.ModifierGroup)
        ) {
            throw new TypeError(
                'modifier_group must be an instance of Mobi2Go._class.MenuItem.ModifierGroup'
            );
        }

        if (!(parent_product instanceof Mobi2Go._class.OrderProduct)) {
            throw new TypeError(
                'product must be an instance of Mobi2Go._class.MenuItem.OrderProduct'
            );
        }

        cid += 1;
        this.cid = cid;
        mixinEvents(`OrderProductModifierGroup#${this.cid}`, this);

        this.menu_modifier_group = modifier_group;
        this.parent_product = parent_product;

        this.modifiers = [];
        this.sub_products = [];

        this.free_modifier_credit = modifier_group.free_modifier_credit;

        // Whether this modifier group has met selection requirement.
        this.selection_requirement = modifier_group.selection_requirement;
        this.selection_requirement_met = true;
        // Whether this modifier group has met selection limit.
        this.selection_limit = modifier_group.selection_limit;
        this.selection_limit_met = false;
        // Number of selected modifiers for this group
        // (aggregated quantity of each modifier)
        this.selection_count = 0;

        this.visible = true;
        this.collapsed = false;
        this.is_restricted = false;

        loadModifiers.call(this);

        this.updateRestriction();
        this.updateSelectionCount();
    },

    updateRestriction() {
        const location = Mobi2Go.Order.getLocation();
        if (!location) {
            return;
        }

        const is_restricted = Mobi2Go.Order.isModifierGroupRestricted(
            this.menu_modifier_group
        );
        if (is_restricted === this.is_restricted) {
            return;
        }

        this.is_restricted = is_restricted;
        this.parent_product._triggerUpdateGroupRestriction(this);
    },

    setSelectionLimit(selection_limit) {
        if (selection_limit === this.selection_limit) {
            return;
        }

        this.selection_limit = selection_limit;
        this.parent_product._triggerUpdateGroupSelectionLimit(this);
        this.updateSelectionLimitMet();
    },

    setSelectionRequirement(selection_requirement) {
        if (selection_requirement === this.selection_requirement) {
            return;
        }

        this.selection_requirement = selection_requirement;
        this.parent_product._triggerUpdateGroupSelectionRequirement(this);
        this.updateSelectionRequirementMet();
    },

    setSelectionStateForAll(selection_state) {
        _.each(this.modifiers, function(modifier) {
            modifier.setSelectionState(selection_state);
        });
    },

    setQuantityForAll(new_quantity) {
        _.each(this.modifiers, function(modifier) {
            modifier.setQuantity(new_quantity);
        });
    },

    setVisible(visible) {
        if (this.visible === !!visible) {
            return;
        }
        this.visible = !!visible;
        this.parent_product._triggerUpdateGroupVisiblity(this);

        this.updateSelectionRequirementMet();
    },

    getCollapsed() {
        return this.collapsed;
    },

    setCollapsed(collapsed) {
        if (this.collapsed === !!collapsed) {
            return;
        }
        this.collapsed = !!collapsed;
        this.parent_product._triggerUpdateGroupCollapsed(this);
    },

    getSubProducts() {
        return this.sub_products;
    },

    setSubProducts(new_sub_products) {
        this.removeAllSubProducts();
        new_sub_products.forEach(new_sub_product => {
            if (new_sub_product instanceof Mobi2Go._class.OrderProduct) {
                new_sub_product.setModifierGroup(this);
                this.addSubProduct(new_sub_product);
                return;
            }

            const new_sub_product_instance = new Mobi2Go._class.OrderProduct(
                {...new_sub_product, modifier_group: this}
            );
            this.addSubProduct(new_sub_product_instance);
        });
    },

    removeAllSubProducts() {
        const sub_products_to_remove = this.getSubProducts();
        sub_products_to_remove.forEach(sb => this.removeSubProduct(sb));
    },

    getAvailableSubProducts() {
        return this.menu_modifier_group.getProducts();
    },

    getSubProductQuantityOfMenuProduct(menu_product) {
        return this.getSubProducts().filter(
            sp => menu_product.id === sp.menu_product.id
        ).length;
    },

    /**
     * Returns quantity of subproducts grouped by menu product
     */
    getSubProductQuantities() {
        return this.getAvailableSubProducts().map(menu_product => {
            return {
                menu_product,
                quantity: this.getSubProductQuantityOfMenuProduct(menu_product),
            };
        });
    },

    addSubProduct(sub_product) {
        const { selection_limit } = this;
        if (selection_limit > 0) {
            // Automatically unselect any other modifier - 'radio button' style selection
            if (selection_limit === 1) {
                this.removeAllSubProducts();
            }

            const { selection_count } = this;

            if (selection_count >= selection_limit) {
                this.parent_product._triggerGroupSelectionLimitWarning(this);

                return;
            }
        }

        sub_product.setModifierGroup(this);

        this.sub_products.push(sub_product);
        this.parent_product._triggerAddSubProduct(sub_product, this);
        this.parent_product.calculateTotal();
        this.updateSelectionCount();
    },

    removeSubProduct(sub_product_to_remove) {
        this.sub_products = this.sub_products.filter(sub_product => {
            return sub_product.cid !== sub_product_to_remove.cid;
        });
        this.parent_product._triggerRemoveSubProduct(
            sub_product_to_remove,
            this
        );
        this.parent_product.calculateTotal();
        this.updateSelectionCount();
    },

    /*--------------------------------------------------------------------------
     * Updates the count of modifiers selected for this modifier group
     */

    updateSelectionCount() {
        if (this.menu_modifier) return;
        const modifier_count = _.reduce(
            this.modifiers,
            (memo, modifier) => memo + modifier.quantity,
            0
        );
        const sub_product_count = this.sub_products.length;
        const count = modifier_count + sub_product_count;

        if (count !== this.selection_count) {
            this.selection_count = count;
            this.parent_product._triggerUpdateGroupSelectionCount(this);
            this.trigger('updateSelectionCount', this);
        }

        this.updateSelectionRequirementMet();
        this.updateSelectionLimitMet();
    },

    /*--------------------------------------------------------------------------
     * Updates this.selection_requirement_met
     */

    updateSelectionRequirementMet() {
        let new_status;
        if (this.visible) {
            new_status = this.selection_count >= this.selection_requirement;
        } else {
            new_status = true;
        }
        if (new_status !== this.selection_requirement_met) {
            this.selection_requirement_met = new_status;
            this.parent_product._triggerUpdateGroupSelectionRequirementMet(
                this
            );
            if (!this.parent_product.mute) {
                this.trigger('updateSelectionRequirementMet', this);
            }
        }
    },

    /*--------------------------------------------------------------------------
     * Updates this.selection_limit_met
     */

    updateSelectionLimitMet() {
        const new_status = this.selection_count >= this.selection_limit;
        if (new_status !== this.selection_limit_met) {
            this.selection_limit_met = new_status;
            this.parent_product._triggerUpdateGroupSelectionLimitMet(this);
            if (!this.parent_product.mute) {
                this.trigger('updateSelectionLimitMet', this);
            }
        }
    },

    /*--------------------------------------------------------------------------
     * Reset free credit for price calculation
     */

    resetFreeCredit() {
        this.free_modifier_credit = +this.menu_modifier_group
            .free_modifier_credit;
    },

    /*--------------------------------------------------------------------------
     * Applies free credit to a modifier's price + returning the amount
     * of the modifier after credit has been applied for product's price calc
     */

    applyFreeCredit(amount) {
        let new_amount = +amount;

        if (!this.free_modifier_credit) return new_amount;

        new_amount -= this.free_modifier_credit;
        this.free_modifier_credit -= amount;

        if (this.free_modifier_credit < 0) this.free_modifier_credit = 0;
        if (new_amount < 0) new_amount = 0;

        return new_amount;
    },
});

/*------------------------------------------------------------------------------
 * toString - extend doesn't work on prototype in IE8...
 */

ModifierGroup.prototype.toString = function() {
    return this.menu_modifier_group.name;
};

/*------------------------------------------------------------------------------
 * Load child modifier objects
 */

function loadModifiers() {
    const Modifier = Mobi2Go._class.OrderProductModifier;

    this.menu_modifier_group.getModifiers().each(menu_modifier => {
        // Skip duplicate modifiers
        if (this.parent_product.getModifierByMenuId(menu_modifier.id)) {
            return;
        }

        const modifier = Modifier(menu_modifier, this);

        this.parent_product.modifiers.push(modifier);
        this.modifiers.push(modifier);
    });
}
